<template lang="html">
  <div class="input-prompt is-flex">
    <div class="centerit">
      <div class="centerit-body">
        <div class="input-prompt-box box is-padded-large">
          <div class="content has-text-centered">
            <div class="is-padded-medium has-border-bottom">
              <h3 class="title is-size-5">{{ title }}</h3>
              <p v-if="message" class="subtitle is-size-6">{{ message }}</p>
            </div>
            <div class="is-padded-medium">
              <input
                ref="inputField"
                v-model="value"
                :type="inputType"
                class="input is-large"
                :placeholder="placeholder"
                :autocomplete="autocomplete"
                @keyup.enter="handleConfirm"
              />
              <p v-if="error" class="help is-size-5 is-danger">{{ error }}</p>
            </div>
            <div class="columns centered">
              <a
                class="column button is-large is-rounded is-black is-outlined"
                @click="handleCancel"
              >
                Cancel
              </a>
              <a
                class="column button is-large is-rounded is-primary"
                :disabled="!value || processing"
                @click="handleConfirm"
              >
                {{ processing ? 'Processing...' : confirmText }}
              </a>
            </div>
          </div>
          <div class="status-icon is-large" :class="iconClass">
            <span class="icon">
              <i class="la" :class="iconName"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'input-prompt',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    inputType: {
      type: String,
      required: false,
      default: 'text',
      validator: value =>
        ['text', 'password', 'email', 'number'].includes(value),
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'off',
    },
    confirmText: {
      type: String,
      required: false,
      default: 'Confirm',
    },
    iconName: {
      type: String,
      required: false,
      default: 'la-question-circle',
    },
    iconClass: {
      type: String,
      required: false,
      default: 'is-warning',
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      value: '',
      error: '',
      processing: false,
    };
  },
  mounted() {
    // Auto-focus the input field when modal opens
    this.$nextTick(() => {
      if (this.$refs.inputField) {
        this.$refs.inputField.focus();
      }
    });
  },
  methods: {
    async handleConfirm() {
      if (!this.value || this.processing) return;

      this.error = '';
      this.processing = true;

      try {
        await this.onConfirm(this.value);
        this.$modal.hide('input-prompt');
      } catch (error) {
        this.error = error.message || 'An error occurred. Please try again.';
        this.processing = false;
      }
    },
    handleCancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.$modal.hide('input-prompt');
    },
  },
};
</script>

<style lang="stylus" scoped>
.input-prompt {
  flex-direction: column;
  margin: auto;
  padding: 20px;
  max-width: 25em;
  overflow: visible;

  @media screen and (max-width 765px - 1px) and (max-height 765px) {
    height: 100vh;
  }

  .centerit {
    flex-grow: 1;

    .centerit-body {
      max-width: 300pt;
    }
  }

  .input-prompt-box {
    padding-bottom: 1rem;
    margin-bottom: 4rem;
    position: relative;
    box-shadow: 0 10px 300.0px rgba(#100, 0.5);

    .status-icon {
      position: absolute;
      bottom: -2.25rem;
      left: calc(50% - 2.25rem - 2px);
      border-width: 4px;
      border-color: white;
    }
  }
}

.button.column {
  display: flex;
  margin: 0.7em;
}
</style>
